var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.canNativeShare)?_c('a',{staticClass:"text-link hover:underline cursor-pointer",on:{"click":_vm.nativeShareInfo}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }